<div [formGroup]="form">
  <h4 class="mb-0 mt-4">Leverantörens organisationer</h4>

  @if (externOrganisationerFormArray.hasError('duplicate')) {
    <rask-validation-message-row
      class="mt-2"
      type="error"
      message="Kod måste vara unikt för alla leverantörs organisationer">
    </rask-validation-message-row>
  }

  <div class="d-flex mb-4" [formGroup]="createLeverantorsOrganisationForm">
    <rask-input class="ps-0" label="Namn *" formControlName="namn"></rask-input>
    <rask-input label="Kod *" formControlName="externKod"></rask-input>
    <rask-button color="secondary" class="mt-auto" (click)="createRow()">Lägg till organisation</rask-button>
    @if (getValidationErrors(); as errors) {
      @if (errors.length > 0) {
        <rask-icon
          #icon
          icon="far fa-circle-exclamation error"
          ngClass="error-icon mt-auto"
          popoverClass="popover-error popover-no-max-width">
          <div class="popover-message-container">
            @for (error of errors; track error) {
              <div class="popover-message">
                {{error}}
              </div>
            }
          </div>
        </rask-icon>
      }
    }
  </div>

  <table class="simple-table">
    <thead>
      <tr>
        <th>Namn *</th>
        <th>Kod *</th>
        <th>Aktiv</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <ng-container formArrayName="externOrganisationer">
        @for (row of externOrganisationerFormArray.controls; track row; let i = $index) {
          <ng-container [formGroup]="row">
            <tr>
              <td [ngClass]="{'td-error': !!row.controls.namn.errors}">
                <rask-input class="td-input" formControlName="namn"></rask-input>
              </td>
              <td [ngClass]="{'td-error': !!row.controls.externKod.errors}">
                <rask-input class="td-input" formControlName="externKod"></rask-input>
              </td>
              <td>
                <rask-checkbox formControlName="aktiv"></rask-checkbox>
              </td>
              <td>
                @if (row.controls.removable.value) {
                  <rask-icon-button
                    ngbTooltip="Ta bort"
                    icon="far fa-trash-alt"
                    negative (click)="removeRow(i)" aid="buttonTaBortLeverantorsOrganisation">
                  </rask-icon-button>
                }
              </td>
            </tr>
          </ng-container>
        }
      </ng-container>
    </tbody>
  </table>
</div>